import styles from './watchlist-modal.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { updateWatchlist } from 'actions/watchlist-actions'
import { AppState } from 'redux/reducers'
import i18n from 'constants/strings'
import { useModalDispatch, useModalState } from 'hooks/use-modal'
import { WatchlistsModalsState, WatchlistsModalId } from 'constants/modals'
import ModalWTN from 'components/generic/ModalWTN'
import WatchlistNameField, { useWatchlistNameField } from '../common/WatchlistNameField'
import { useEffect } from 'react'

const RenameWatchListModal = () => {
  const dispatch = useDispatch()
  const { watchlistId } = useModalState<WatchlistsModalsState, WatchlistsModalId.RENAME_WATCHLIST>(
    WatchlistsModalId.RENAME_WATCHLIST
  )
  const { modalDispatch, modalActions } = useModalDispatch<
    WatchlistsModalsState,
    WatchlistsModalId.RENAME_WATCHLIST
  >(WatchlistsModalId.RENAME_WATCHLIST)
  const watchlists = useSelector((state: AppState) => state.watchlists.watchlists)
  const currentName = watchlists[watchlistId]?.name
  const otherExistingWatchlistsNames = Object.values(watchlists)
    .map(w => w.name)
    .filter(name => name !== currentName)
  const { value, validate, clearError, setValue, props } = useWatchlistNameField({
    forbiddenNames: otherExistingWatchlistsNames,
  })

  const handleCancel = () => {
    modalDispatch(modalActions.closeModal())
    if (!value) clearError()
    if (currentName) setValue(currentName)
  }

  const handleConfirm = () => {
    const error = validate(value)
    if (!error) {
      modalDispatch(modalActions.closeModal())
      dispatch(updateWatchlist(watchlistId, { name: value }))
    }
  }

  useEffect(() => {
    if (currentName) setValue(currentName)
  }, [currentName, setValue])

  return (
    <ModalWTN
      className={styles.renameModal}
      modalId={WatchlistsModalId.RENAME_WATCHLIST}
      widgetElId='watchlists'
      textHeader={i18n.t('strWatchlists.renameModal.title')}
      reducedHeaderMargin
      btnAlignment='right'
      btnPrimary={{
        text: i18n.t('strCommonUI.button.update'),
        onClick: handleConfirm,
      }}
      btnSecondary={{
        text: i18n.t('strCommonUI.button.cancel'),
        onClick: handleCancel,
      }}
    >
      <p className={styles.info}>{i18n.t('strWatchlists.renameModal.info')}</p>
      <WatchlistNameField {...props} />
    </ModalWTN>
  )
}

export default RenameWatchListModal
